import './Layout.css'

import { authContext } from 'adalConfig'
import { BottomMenuContainer, DateMenuContainer, SideMenuContainer } from 'menu'
import type { ReactNode } from 'react'
import React, { Component } from 'react'
import { Search } from 'search'

import Box from '@mui/material/Box'

import { AppHeaderContainer } from '../index'

interface Props {
  children?: ReactNode
}

class Layout extends Component<Props> {
  logout = () => {
    authContext.logOut()
  }

  render() {
    return (
      <Box className="layout page home-page">
        <Box className="flex-wrapper">
          <SideMenuContainer logout={this.logout} />
          <BottomMenuContainer />
        </Box>
        <main className="content">
          <header>
            <AppHeaderContainer showMenuIcon />
            <DateMenuContainer />
          </header>
          <section>{this.props.children}</section>
        </main>
        <Search />
      </Box>
    )
  }
}

export default Layout
